<div class="rl">
  @if (invalids.length) {
  <div class="rl__head">
    <p class="rl__intro">
      These numbers could not be read as phone numbers and will be skipped. Select one to correct
      it. For many, download them and fix them in a spreadsheet.
    </p>
    <button type="button" class="bk-btn bk-btn--ghost rl__download" (click)="downloadInvalids()">
      <span class="bk-sym" aria-hidden="true">download</span>
      Download invalid numbers
    </button>
  </div>
  <ul class="phoneNumbers rl__list">
    @for (invalid of invalids; track $index) {
    <li class="invalid rl__entry">
      <button
        type="button"
        class="rl__item rl__item--invalid"
        [attr.aria-label]="'Correct ' + (invalid.phoneNumber || 'empty row') + ', invalid'"
        (click)="openUpdateModal(invalid)"
      >
        <span class="rl__dot" aria-hidden="true"></span>
        <span class="number">{{ invalid.phoneNumber || '(empty)' }}</span>
        <span class="bk-sym rl__pen" aria-hidden="true">edit</span>
      </button>
    </li>
    }
  </ul>
  } @else {
  <div class="noInvalids rl__empty">
    <span class="bk-sym" aria-hidden="true">check_circle</span>
    <p class="rl__empty-title">No invalid numbers</p>
    <p class="rl__empty-body">Every number in the file can be sent to.</p>
  </div>
  }

  <!-- MODAL -->
  <modal-form-container
    [showModal]="showUpdateModal"
    title="Correct phone number"
    (closeModalEvent)="closeUpdateModal()"
  >
    <div class="updatePhoneNumberBody rl__edit">
      <p class="rl__intro">
        Enter the number with its country code. It is checked again as soon as you save.
      </p>

      <form [formGroup]="phoneNumberForm" (ngSubmit)="updatePhoneNumber()" class="rl__form">
        <input-field
          label="Phone number"
          [errorMessage]="
            phoneNumberSubmitted && phoneNumberForm.controls.phoneNumber.invalid
              ? 'Enter a valid phone number, including the country code.'
              : ''
          "
          class="w-full"
        >
          <ngx-mat-input-tel
            formControlName="phoneNumber"
            [enablePlaceholder]="true"
            [preferredCountries]="['bw', 'za']"
            [enableSearch]="true"
          />
        </input-field>

        <div class="rl__form-actions">
          <button type="button" class="bk-btn bk-btn--ghost" (click)="closeUpdateModal()">Close</button>
          <button type="submit" class="bk-btn bk-btn--primary">Save number</button>
        </div>
      </form>
    </div>
  </modal-form-container>
</div>
